// extracted by mini-css-extract-plugin
export var figureWithLengthIndicator = "cell-biochip-module--figure-with-length-indicator--ur4ck";
export var figureWithZoomIndicator = "cell-biochip-module--figure-with-zoom-indicator--L2cC4";
export var lengthIndicator = "cell-biochip-module--length-indicator--+CiqK";
export var lengthIndicator1 = "cell-biochip-module--length-indicator-1--xIKiR";
export var lengthIndicator2 = "cell-biochip-module--length-indicator-2--jKJ-5";
export var lengthIndicator3 = "cell-biochip-module--length-indicator-3--eypNb";